module.exports = __webpack_public_path__ + "01_face.f38dd1bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer1/01_face.png
// module id = DNyN
// module chunks = 0